export enum CustomizerStateConstants {
    NEWORDER = "New Order",
    ADDEDORDER = "Added Order",
    EDITORDER = "Edit Order"
}
